import makeUseCellCopyAction, {
  UseCellCopyActionProps,
} from "ds/components/Table/helpers/makeUseCellCopyAction";

const useCellCopyAction = (props: UseCellCopyActionProps) => {
  return makeUseCellCopyAction()(props);
};

export default useCellCopyAction;
